/** @format */

import { createSelector } from '@ngrx/store';
import { selectProductReviewState } from './product-reviews.selector';

/**
 * @description
 * Handles each different scenario for product Reviews functionality
 */

export const selectProductReviewUi = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsUiState
);

export const selectProductReviewDrawer = createSelector(
	selectProductReviewUi,
	(state) => state.productListDrawer
);

export const selectProductReviewSlider = createSelector(
	selectProductReviewUi,
	(state) => state.slider
);

export const selectProductReviewImageModal = createSelector(
	selectProductReviewUi,
	(state) => state.imageModal
);
